export const SideBarWidget = ({ children }) => {
  return <div className="col-md-4 mt-3 mt-md-0">{children}</div>;
};
